const Shadows = (theme) => {
    return { ...theme.shadows, mainShadow: "rgba(76, 78, 100, 0.22) 0px 2px 10px 0px" };
};
export default Shadows;
